export default "__VITE_ASSET__3dfd3362__"